export default __webpack_public_path__ + "static/media/gallery 2.055435b6.png";